// Note: jQuery has been removed from this project
// Import ClipboardJS exposure for backward compatibility

import expose from 'lib/expose';
import kebabCase from 'lodash/kebabCase';
import ClipboardJS from 'clipboard';

// Load Custom Plugins (vanilla JS now)
import 'plugins';

// Exposing dependencies shared with asset pipeline.
expose({
  kebabCase,
  ClipboardJS
});
